<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BasketUtils",
  computed: {
    ...mapGetters('order', {
      isCheckout: 'getIsCheckout',
      isConfirmOrder: 'getIsConfirmOrder',
      productItems: 'basketItems',
    }),
    ...mapGetters('user', {
      isUserAuthorize: 'isAuthorize',
    }),
    ...mapGetters('app', {
      pizzeriaInfo: 'getPizzeriaInfo'
    }),
  },
  methods:{
    showCheckoutForm: function () {
      return this.isCheckout && this.isUserAuthorize && !this.isConfirmOrder;
    },
    openCertificateModal: function (){
      this.$store.commit("basket/setIsOpenCertificateModal", true);
    },
    showBasketListFooter: function(){
      return !this.isConfirmOrder && !this.showCheckoutForm();
    },
    isBasketEmpty: function (){
      return this.productItems.length === 0;
    }
  }
}
</script>

<style scoped>

</style>